<template>
  <div class="phishing-check">
    <FormbarPhishingCheck
      @updateLinkSecurityStatus="updateLinkSecurityStatus"
    />
    <div class="phishing-check__message phishing-check__message_link-is-safe" v-if="linkSecurityStatus === 2">
      <p class="phishing-check__title">Ссылка безопасна</p>
      <p class="phishing-check__description">
        Вы перешли на официальный сайт Boxberry, и вам ничего не угрожает.
        Проверяйте ссылки на безопасность, прежде чем оплатить товар, и совершайте покупки на площадках частных объявлений без риска.
      </p>
    </div>
    <div class="phishing-check__message phishing-check__message_link-is-unsafe" v-if="linkSecurityStatus === 1">
      <p class="phishing-check__title">Ссылка небезопасна</p>
      <p class="phishing-check__description">
        Ни в коем случае не переходите по ней, а если все-таки перешли – не вводите личные данные и реквизиты банковских карт.
        Помните, что Boxberry не принимает оплату на своем сайте и не требует ввода реквизитов,
        если сделка была оформлена на площадках частных объявлений.
      </p>
    </div>
  </div>
</template>
<script>
import FormbarPhishingCheck from './FormbarPhishingCheck.vue';

export default {
  name: 'PhishingCheck',
  components: {
    FormbarPhishingCheck,
  },
  data() {
    return {
      linkSecurityStatus: 0,
    };
  },
  methods: {
    updateLinkSecurityStatus(value) {
      this.linkSecurityStatus = value;
    },
  },
};
</script>
<style lang="scss">
  @import 'PhishingCheck';
</style>
